/* CTUS PDP: large variant buttons, qty steppers, savings + sticky price sync, mobile sticky Add to Cart. */
(function () {
  'use strict';
  var form = document.querySelector('#ProductSection form.product-form'); if (!form) return;
  var json = document.querySelector('[id^="ProductJson-"]'); var product = null;
  try { product = JSON.parse(json.textContent); } catch (e) {}
  function money(c) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c, (window.theme && theme.moneyFormat) || '${{amount}}') : '$' + (c / 100).toFixed(2); }


  // 0) Server-rendered pills (ctus-variant-pills.liquid): wire to the id select + theme option selects.
  (function () {
    var box = form.querySelector('[data-ctus-vpills]'); if (!box) return;
    var idSel = form.querySelector('select[name="id"]');
    function pick(id) {
      var v = null; if (product) for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === String(id)) v = product.variants[i];
      if (idSel) idSel.value = id;
      var opts = form.querySelectorAll('.single-option-selector');
      if (v && opts.length) { opts.forEach(function (s, i) { var val = v.options[i]; if (val != null) { s.value = val; } }); opts[opts.length - 1].dispatchEvent(new Event('change', { bubbles: true })); }
      else if (idSel) idSel.dispatchEvent(new Event('change', { bubbles: true }));
      if (idSel) idSel.value = id;
      box.querySelectorAll('.ctus-vpill').forEach(function (b) { var on = b.dataset.variantId === String(id); b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      if (v) { var pp = document.getElementById('ProductPrice'); if (pp) { pp.textContent = money(v.price); pp.setAttribute('content', (v.price / 100).toFixed(2)); } }
      if (window.history && history.replaceState) { try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u.toString()); } catch (e) {} }
      setTimeout(sync, 0);
    }
    box.addEventListener('click', function (e) { var b = e.target.closest('.ctus-vpill'); if (b && !b.disabled) pick(b.dataset.variantId); });
    form.querySelectorAll('.selector-wrapper').forEach(function (w) { w.__ctus = 1; });
    var mo = new MutationObserver(function () { form.querySelectorAll('.selector-wrapper').forEach(function (w) { w.__ctus = 1; }); });
    mo.observe(form, { childList: true, subtree: true });
  })();
  // 1) Variant dropdowns -> big labeled buttons (dropdown stays in DOM as the source of truth).
  function buildButtons() {
    form.querySelectorAll('.selector-wrapper').forEach(function (wrap, idx) {
      var sel = wrap.querySelector('select'); if (!sel || wrap.__ctus) return;
      if (sel.options.length < 2) { wrap.classList.add('ctus-single'); wrap.__ctus = 1; return; }
      wrap.__ctus = 1; wrap.classList.add('ctus-has-buttons');
      var lab = wrap.querySelector('label');
      var group = document.createElement('div'); group.className = 'ctus-opts'; group.setAttribute('role', 'radiogroup');
      if (lab) group.setAttribute('aria-label', lab.textContent.trim());
      Array.prototype.forEach.call(sel.options, function (o) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ctus-opt'; b.textContent = o.text;
        b.setAttribute('role', 'radio'); b.dataset.value = o.value;
        b.addEventListener('click', function () { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); sync(); });
        group.appendChild(b);
      });
      sel.classList.add('ctus-visually-hidden'); sel.setAttribute('tabindex', '-1'); sel.setAttribute('aria-hidden', 'true');
      wrap.appendChild(group);
    });
    sync();
  }
  function currentVariant() {
    var id = (form.querySelector('select[name="id"]') || {}).value;
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === String(id)) return product.variants[i];
    return null;
  }
  function sync() {
    form.querySelectorAll('.ctus-has-buttons').forEach(function (wrap) {
      var sel = wrap.querySelector('select');
      wrap.querySelectorAll('.ctus-opt').forEach(function (b) {
        var on = b.dataset.value === sel.value; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    });
    // mark sold-out combos (single-option products only, which is all of this store)
    if (product && product.options.length === 1) {
      form.querySelectorAll('.ctus-opt').forEach(function (b) {
        var v = product.variants.filter(function (x) { return x.option1 === b.dataset.value; })[0];
        if (v && !v.available) { b.classList.add('is-soldout'); if (!/sold out/i.test(b.textContent)) b.textContent += ' – Sold out'; }
      });
    }
    var v = currentVariant(); if (!v) return;
    var sp = document.querySelector('[data-ctus-sticky-price]'); if (sp) sp.textContent = money(v.price);
    var sv = document.getElementById('CtusSave');
    if (sv) { if (v.compare_at_price > v.price) { sv.hidden = false; sv.querySelector('[data-ctus-save-amt]').textContent = money(v.compare_at_price - v.price); } else sv.hidden = true; }
    var sb = document.querySelector('[data-ctus-sticky-btn]'); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
  }
  form.addEventListener('change', function () { setTimeout(sync, 0); });
  // 10/21: re-sync sticky price on back/forward cache restores and after late theme init.
  window.addEventListener('pageshow', function () { setTimeout(sync, 0); });
  setTimeout(sync, 800);

  // 2) Quantity steppers.
  var q = document.getElementById('Quantity');
  if (q && !q.__ctus) {
    q.__ctus = 1;
    var w = document.createElement('div'); w.className = 'ctus-qty';
    var minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'Decrease quantity');
    var plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'Increase quantity');
    q.parentNode.insertBefore(w, q); w.appendChild(minus); w.appendChild(q); w.appendChild(plus);
    minus.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
    plus.addEventListener('click', function () { q.value = (parseInt(q.value, 10) || 1) + 1; });
  }

  // 3) Mobile sticky Add to Cart: shows once the main button scrolls out of view.
  var sticky = document.getElementById('CtusSticky'); var atc = document.getElementById('AddToCart');
  if (sticky && atc) {
    sticky.querySelector('[data-ctus-sticky-btn]').addEventListener('click', function () { atc.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0]; var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        var before = !e.isIntersecting && e.boundingClientRect.top > 0;
        var show = past || before; sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      }).observe(atc);
    }
  }

  // 4) Ship-today countdown. Cutoff 12:00 PM ET Mon–Fri; closures from CTM's list.
  var CLOSED = ['2026-10-12','2026-11-26','2026-12-24','2026-12-25','2026-12-26','2027-01-01','2027-01-18','2027-03-28','2027-05-31','2027-06-18','2027-07-04','2027-09-06'];
  function etParts(d) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' });
    var o = {}; f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { ymd: o.year + '-' + o.month + '-' + o.day, h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10), wd: o.weekday };
  }
  function isBiz(p) { return p.wd !== 'Sat' && p.wd !== 'Sun' && CLOSED.indexOf(p.ymd) === -1; }
  function cutoff() {
    var el = document.getElementById('CtusCutoff'); if (!el) return;
    var now = new Date(); var p = etParts(now);
    if (isBiz(p) && p.h < 12) {
      var mins = (12 * 60) - (p.h * 60 + p.m); var h = Math.floor(mins / 60), m = mins % 60;
      el.textContent = 'Order in ' + (h ? h + 'h ' : '') + m + 'm to ship today';
      return;
    }
    for (var i = 1; i < 15; i++) {
      var d = new Date(now.getTime() + i * 86400000); var q = etParts(d);
      if (isBiz(q)) {
        var label = i === 1 ? 'tomorrow' : new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'long', month: 'short', day: 'numeric' }).format(d);
        el.textContent = 'Ships ' + label + (i === 1 ? ' (' + new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'long' }).format(d) + ')' : '') + ' – order cutoff is 12 PM ET';
        return;
      }
    }
  }
  cutoff(); setInterval(cutoff, 30000);

  if (document.readyState === 'complete') buildButtons(); else window.addEventListener('load', buildButtons);
  setTimeout(buildButtons, 1500);
})();
